import React, { useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Conditional from '../../../../components/Conditional/Conditional';
import { isBrowser } from '../../../../utils/environment';
import { logPageview } from '../../../../utils/linkpulse';
import { trackCustomEvent } from '../../../../utils/statistics/clientStatistics';
import { expandListClick } from '../../../../utils/statistics/customEvents';
import AccessibilityLinks from '../../../AccessibilityLinks/AccessibilityLinks';
import AccessibilityText from './components/AccessibilityText/AccessibilityText';
import EditButtons from './components/EditButtons/EditButtons';
import ExpandCollapseButton from './components/ExpandCollapseButton/ExpandCollapseButton';
import { Heading, Link, RemoveItemsButton, RemoveItemsButtonTransition, StyledHeader } from './Header.styles';

const Header = (props) => {
    const {
        id,
        regTestSpec,
        url,
        text,
        expanded,
        expandable,
        allItemsVisible,
        changeLayout,
        showEditButtons,
        markedAsDeleted,
        onEditDone,
        onEditModeActivated,
        showAccessibilityLinks,
        videoContext,
    } = props;

    const accessibilityText = useRef(null);

    const [editModeActivated, toggleEditModeActivated] = useState(false);

    if (!text && !showAccessibilityLinks) {
        return null;
    }

    const logLinkpulse = () => {
        if (isBrowser()) {
            logPageview({
                title: document.title,
            });
        }
    };

    const toggleExpand = (e) => {
        e.preventDefault();
        changeLayout(id);
        logLinkpulse();

        let action = !expanded ? 'expand' : 'collapse';

        const eventData = {
            listId: id,
            action: action,
        };

        trackCustomEvent(expandListClick(eventData));
    };

    const toggleEditMode = (e) => {
        e.preventDefault();
        if (editModeActivated) {
            onEditDone();
        } else {
            onEditModeActivated();
        }
        toggleEditModeActivated(!editModeActivated);
    };

    return (
        <StyledHeader>
            <Heading
                data-rt="slidable-list-header"
                data-rt-spec={regTestSpec}
                noBottomPadding={showAccessibilityLinks}
            >
                <Conditional condition={showAccessibilityLinks}>
                    <AccessibilityLinks videoContext={videoContext} isVisible />
                </Conditional>
                <Conditional condition={!showAccessibilityLinks}>
                    <Conditional condition={url}>
                        <Link to={url}>
                            <span>{text}</span>
                            <span className="play_bumping-arrow-icon" aria-hidden="true" />
                        </Link>
                    </Conditional>
                    <Conditional condition={!url}>
                        <span>{text}</span>
                    </Conditional>
                </Conditional>
            </Heading>
            <Conditional condition={expandable && !allItemsVisible && !showEditButtons}>
                <ExpandCollapseButton expanded={expanded} toggleExpand={toggleExpand} text={text} />
            </Conditional>
            <Conditional condition={showEditButtons}>
                <RemoveItemsButton type="button" onClick={toggleEditMode}>
                    <TransitionGroup>
                        <CSSTransition
                            key={`edit-mode-${editModeActivated}`}
                            mountOnEnter={true}
                            unmountOnExit={true}
                            timeout={150}
                        >
                            <RemoveItemsButtonTransition>
                                <EditButtons
                                    markedAsDeleted={markedAsDeleted}
                                    text={text}
                                    editModeActivated={editModeActivated}
                                />
                            </RemoveItemsButtonTransition>
                        </CSSTransition>
                    </TransitionGroup>
                </RemoveItemsButton>
            </Conditional>
            <span ref={accessibilityText} tabIndex="-1">
                <AccessibilityText expanded={expanded} editModeActivated={editModeActivated} />
            </span>
        </StyledHeader>
    );
};

export default Header;
